/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_ChatInputs */



/**
* | output |
* | --- |
* | "24/7 Email & Live Chat Support" |
*
* @param {Signup_Compare_ChatInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_chat = /** @type {((inputs?: Signup_Compare_ChatInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_ChatInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("24/7 Email & Live Chat Support")
	if (locale === "de") return /** @type {LocalizedString} */ ("24/7 Email & Live Chat Support")
	if (locale === "it") return /** @type {LocalizedString} */ ("24/7 Email & Live Chat Support")
	if (locale === "ru") return /** @type {LocalizedString} */ ("24/7 Email & Live Chat Support")
	if (locale === "es") return /** @type {LocalizedString} */ ("24/7 Email & Live Chat Support")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("24/7 Email & Live Chat Support")
	if (locale === "ja") return /** @type {LocalizedString} */ ("24/7 Email & Live Chat Support")
	if (locale === "hi") return /** @type {LocalizedString} */ ("24/7 Email & Live Chat Support")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("24/7 Email & Live Chat Support")
	return /** @type {LocalizedString} */ ("24/7 Email & Live Chat Support")
});